import React from "react";

import CrossSvg from "../../assets/icons/cross.svg";
import IconSvg from "../IconSvg";

import { SMALL_SCREEN } from "../../utils/breackpoints";

import useModalAnimated from "../../hooks/useModalAnimated";
import useMediaQuery from "../../hooks/useMediaQuery";

const Modal = ({
  children,
  closeModal,
  headingTitle,
  isInMeetRoom = false,
  maxWidth = "800px",
}) => {
  const { isAnimated } = useModalAnimated();

  const isPhoneScreen = useMediaQuery(SMALL_SCREEN);

  const getModalWidth = () => {
    if (isPhoneScreen) return "90%";
    else return maxWidth;
  };

  return (
    <div
      className={`modal ${isAnimated ? "active" : ""} ${isInMeetRoom ? "is-in-meetroom" : ""}`}
    >
      <div className="modal__frame" style={{ width: getModalWidth() }}>
        <div className="modal__top">
          <div className="modal__header">
            <div className="modal__heading">
              <h2>{headingTitle}</h2>
            </div>
            <div className="icon-frame">
              <IconSvg svg={CrossSvg} onMouseDown={closeModal} />
            </div>
          </div>
        </div>
        <div className="modal__content">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
